import { useState } from 'react';
import {
  Button,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  styled,
} from '@mui/material';
import { ReactComponent as SortIcon } from 'icons/sort.svg';
import { SortDirection, SortType } from 'store/storageunits/types';
import { useDispatch, useSelector } from 'react-redux';
import { setSort } from 'store/storageunits/reducer';
import { getSortDirection, getSortType } from 'store/storageunits/selectors';
import Check from '@mui/icons-material/Check';
import { useTheme } from '@emotion/react';

const SortDirectionButton = styled(IconButton)`
  transition: transform 200ms ease-in-out;
  color: ${({ theme }) => theme.vars.palette.grey[900]};

  &[data-flip='true'] {
    transform: rotate(-180deg);
  }
`;

const CheckedItem = () => (
  <ListItemIcon>
    <Check fontSize='small' />
  </ListItemIcon>
);

const Sort = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const type = useSelector(getSortType);
  const direction = useSelector(getSortDirection);

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSetSortType = (sortType: SortType) => {
    dispatch(setSort({ direction, type: sortType }));
    handleClose();
  };

  const onSetSortDirection = () => {
    dispatch(
      setSort({
        type,
        direction:
          direction === SortDirection.ASC
            ? SortDirection.DESC
            : SortDirection.ASC,
      }),
    );
  };

  return (
    <Stack
      direction='row'
      sx={{
        mr: 0,
      }}
    >
      <Button
        sx={{ textTransform: 'capitalize' }}
        color='tertiary'
        onClick={handleClick}
      >
        {type === SortType.ALPHABETICAL ? 'Name' : 'Last modified'}
      </Button>
      <SortDirectionButton
        data-flip={direction === SortDirection.DESC}
        onClick={onSetSortDirection}
      >
        <SortIcon style={{ color: theme.vars.palette.grey[900] }} />
      </SortDirectionButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => onSetSortType(SortType.LAST_MODIFIED)}>
          {type === SortType.LAST_MODIFIED && <CheckedItem />}
          <ListItemText inset={type !== SortType.LAST_MODIFIED}>
            Last modified
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={() => onSetSortType(SortType.ALPHABETICAL)}>
          {type === SortType.ALPHABETICAL && <CheckedItem />}
          <ListItemText inset={type !== SortType.ALPHABETICAL}>
            Name
          </ListItemText>
        </MenuItem>
      </Menu>
    </Stack>
  );
};

export default Sort;
